<!--<div *ngIf="event!==undefined" class="event-item {{ event.results ? 'has-results' : 'no-results' }}">
  <div class="event-item__logo" (click)="goTo()">
    <img [lazyLoad]="event.logo">
  </div>
  <div class="event-item__info" (click)="goTo()">
    <h3 class="event-item__name">{{ event.name }}</h3>
    <div class="event-item__loc">
      {{ event.place }}, {{ event.countryName }} <img src="{{ event.flag }}" class="flag">
    </div>
    <div class="event-item__date">{{ event.dateString }}</div>
  </div>
  <div class="event-item__flags">
    <span *ngIf="event.isLive" class="live">Live</span>
    <span *ngIf="event.levelLabel" class="level" (click)="filterLevel()">{{ event.levelLabel }}</span>
    <span *ngIf="event.isWRE" class="wre" (click)="filterLevel()">World Ranking</span>
  </div>
</div>
-->

<tr class="wa-table__row calendar__event">
  <td class="wa-table__cell calendar__event__logo" [ngClass]="{'is-featured': event.isfeatured}">
    <img [lazyLoad]="'//extranet.worldarchery.sport/CompetitionLogos/?Id=' + event?.id?.toString()" class="visibility--hide-mobile" />
  </td>

  <td class="wa-table__cell calendar__event__name">
    <div>
      <a [href]="lang + 'competition/'+event?.id?.toString()" class="calendar__event__name" data-th="name">
        {{ event.nameshort !== '' && event.nameshort ? event.nameshort : event.name }}

      </a>

    </div>
  </td>

  <td class="wa-table__cell calendar__event__place">
    <div>{{ event.place }}</div>
    <img [lazyLoad]="event.flag" class="flag" />
  </td>

  <td class="wa-table__cell calendar__event__date">
    <div *ngIf="event?.dateFromObj?.getFullYear() !== event?.dateToObj?.getFullYear()">
      <div>{{ event.dateFromObj | date :'d MMMM yyyy' }}</div>
      <div>{{ event.dateToObj | date : 'd MMMM yyyy' }}</div>
    </div>
    <div *ngIf="(event?.dateFromObj?.getFullYear() === event?.dateToObj?.getFullYear()) && event?.dateFromObj?.getDate() === event?.dateToObj?.getDate()">
      <div>{{ event.dateToObj | date : 'd MMMM' }}</div>
      <div>{{ event.dateToObj | date : 'yyyy' }}</div>
    </div>
    <div *ngIf="(event?.dateFromObj?.getUTCDate() !== event?.dateToObj?.getUTCDate()) && (event?.dateToObj?.getMonth() === event?.dateFromObj?.getMonth())">
      <div>{{ event.dateFromObj | date : 'd '}} - {{event.dateToObj | date : 'd MMMM' }}</div>
      <div>{{ event.dateToObj | date : 'yyyy' }}</div>
    </div>
    <div *ngIf="(event?.dateFromObj?.getUTCDate() !== event?.dateToObj?.getUTCDate()) && (event?.dateToObj?.getMonth() !== event?.dateFromObj?.getMonth())">
      <div>{{ event.dateFromObj | date : 'd MMMM'}} - {{event.dateToObj | date : 'd MMMM' }}</div>
      <div>{{ event.dateToObj | date : 'yyyy' }}</div>
    </div>
  </td>

  <td class="wa-table__cell calendar__event__quicklinks">
    <div class="event-item__flags">
      <span *ngIf="event.isLive" class="live">{{'Live' | transloco}}</span>
      <span *ngIf="event.levelLabel" class="level">{{ event.sublevel != null && event.sublevel != "" ? event.sublevel : event.level }}</span>
      <div>
        <span *ngIf="event.isWorldRanking"  class="tag selectable" (click)="filterLevel(event.levelId)">{{'world_ranking' | transloco}}</span>
      </div>
    </div>
  </td>
</tr>
